<app-codemirror
  #editor
  class="set-variable-textarea mousetrap"
  [extensions]="editorExtensions"
  [ngModel]="variables"
  (ngModelChange)="variablesChange.emit($event)"
></app-codemirror>
